import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslate } from 'react-admin';
import { customPalette } from '../themes/customTheme';

export const ResultsTable = ({
  data,
  teamSelected,
  members,
  teams,
  page,
  rowsPerPage,
}) => {
  const getTeamsName = id => {
    const team = teams.find(team => team.id === id);
    return team ? team.name : '';
  };
  const t = useTranslate();

  const getProcessedData = (target, currentValue, weight) => {
    if (target) {
      return Intl.NumberFormat('es-AR', {}).format(
        Math.round((currentValue * weight) / target)
      );
    }

    return 0;
  };

  if (!data || !data.length) return null;

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell sx={{ width: '50px', textAlign: 'center' }}>
            {t('resources.score.list.fields.top')}
          </TableCell>

          {teamSelected || members ? (
            <TableCell
              sx={{
                width: '200px',
              }}
            >
              {t('resources.score.list.fields.editor')}
            </TableCell>
          ) : null}
          <TableCell
            sx={{
              width: '200px',
            }}
          >
            {t('resources.score.list.fields.team')}
          </TableCell>

          {teamSelected || members ? (
            <TableCell sx={{ width: '100px' }}>
              {t('resources.score.list.fields.visits')}
            </TableCell>
          ) : null}
          {teamSelected || members ? (
            <TableCell sx={{ width: '100px' }}>
              {t('resources.score.list.fields.notes')}
            </TableCell>
          ) : null}
          {teamSelected || members ? (
            <TableCell sx={{ width: '100px' }}>
              {t('resources.score.list.fields.rfv')}
            </TableCell>
          ) : null}
          {teamSelected || members ? (
            <TableCell sx={{ width: '170px' }}>
              {t('resources.score.list.fields.subscribers')}
            </TableCell>
          ) : null}
          <TableCell sx={{ width: '170px' }}>
            {t('resources.score.list.fields.points')}
          </TableCell>
          <TableCell sx={{ width: '170px' }}>
            {t('resources.score.list.fields.accumulated')}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.map((team, i) => (
          <TableRow
            key={i}
            sx={{
              '&:hover': {
                backgroundColor: customPalette.greyStoke,
              },
            }}
          >
            <TableCell
              sx={{
                fontSize: '16px',
                fontWeight: '600',
                color: customPalette.primary.main,
                textAlign: 'center',
              }}
            >
              {members ? page * rowsPerPage + i + 1 : i + 1}
            </TableCell>
            {teamSelected || members ? (
              <TableCell>
                <Typography
                  sx={{
                    textTransform: 'capitalize',
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: '21px',
                  }}
                >
                  {team.user?.username}
                </Typography>
              </TableCell>
            ) : null}
            <TableCell>
              <Typography
                sx={{
                  textTransform: 'capitalize',
                  fontSize: 16,
                  fontWeight: 400,
                  lineHeight: '21px',
                }}
              >
                {teamSelected
                  ? getTeamsName(teamSelected)
                  : team.team?.name || ''}
              </Typography>
            </TableCell>

            {teamSelected || members ? (
              <TableCell>
                {getProcessedData(
                  team.target_visits,
                  team.visits,
                  team.weight_visits
                )}
              </TableCell>
            ) : null}
            {teamSelected || members ? (
              <TableCell>
                {getProcessedData(
                  team.target_notes,
                  team.notes,
                  team.weight_notes
                )}
              </TableCell>
            ) : null}
            {teamSelected || members ? (
              <TableCell>
                {getProcessedData(team.target_rfv, team.rfv, team.weight_rfv)}
              </TableCell>
            ) : null}
            {teamSelected || members ? (
              <TableCell>
                {Intl.NumberFormat('es-AR', {}).format(
                  Math.round(
                    getProcessedData(
                      team.target_subscribers,
                      team.subscribers,
                      team.weight_subscribers
                    )
                  )
                )}
              </TableCell>
            ) : null}
            <TableCell sx={{ display: 'flex', marginLeft: '12px' }}>
              {Intl.NumberFormat('es-AR', {}).format(
                Math.round(team?.total_points || 0)
              )}
            </TableCell>
            <TableCell>
              {Intl.NumberFormat('es-AR', {}).format(
                Math.round(team?.accumulated_points || 0)
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
